import React from "react";
import OfferEditorCommon from "./OfferEditorCommon";

/*
 * Stage 3 - HR
 *
 * HR is the final workflow editor before release/send-offer-letter.
 *
 * The editable field list is NOT declared here. It is passed in as
 * `editableFields` from OffersList, which always supplies EDITABLE_FIELDS.hr —
 * the same list the backend enforces via EDITABLE_FIELDS[editorRole]. A local
 * copy would be silently overridden by the `{...props}` spread and would drift
 * from the real policy, so there is exactly one place to change it.
 */

export default function HROfferEditor(props) {
  return (
    <OfferEditorCommon
      {...props}
      title="Edit Offer - HR"
      stageLabel="Stage 3 - HR"
      showAllFields={true}
      note="HR can update final HR-controlled fields. Approval status and workflow assignment are not editable from this form."
    />
  );
}
